import * as Utils from './utils.js';

const loginModule = (() => {
    /**
    Inputs
     **/
    let button = $('#button_login');
    let form = $('#form-login-user');
    let username = $('#username');
    let password = $('#password');

    let parameters;


    function initLogin(options) {
        parameters = options.parameters;
        listenShowHidePassword();
        listenSubmit();
    }

    function validateInputs(event) {
        let errors = [];
        if (parameters.show_captcha) {
            let captcha = $('[name="cf-turnstile-response"]');
            if (Utils.isNull(captcha.val()) || Utils.isEmpty(captcha.val())) {
                errors.push('* Complete el captcha');
            }
        }

        if (Utils.isNull(username.val()) || Utils.isEmpty(username.val())) {
            errors.push("* Ingrese el usuario");
        }

        if (Utils.isNull(password.val()) || Utils.isEmpty(password.val())) {
            errors.push("* Ingrese la contraseña");
        }

        if (errors.length > 0) {
            event.preventDefault();
            console.warn(errors);
            showWarnings(errors);
        }
    }


    function listenSubmit() {
        button.click(function (event) {
            validateInputs(event);
        });
    }

    function listenShowHidePassword() {
        $('#button-show-hide').on('click', function () {
            let input = $('#password');
            let eye = $('#eye');
            let slashEye = $('#slash-eye');
        
            if (input.attr('type') === 'password') {
                input.attr('type', 'text');
                eye.addClass('d-none');
                slashEye.removeClass('d-none');
            } else {
                input.attr('type', 'password');
                eye.removeClass('d-none');
                slashEye.addClass('d-none');
            }
        });        
    }

    return {
        initLogin // Solo esta función será accesible desde fuera
    };

})();

window.loginModule = loginModule;